// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__71xI9","clickable":"Checkbox_clickable__YjQFq","disabled":"Checkbox_disabled__h5VEk"};